/* Petcetera delivery estimate. Business days only (Mon–Fri), New York time. */
(function () {
  if (window.PetceteraDelivery) { window.PetceteraDelivery.renderAll(); return; }

  function nyNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: false
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (x) { o[x.type] = x.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, min: +o.minute };
  }
  function isBiz(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6; }
  function addBiz(dt, n) {
    var d = new Date(dt.getTime());
    while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (isBiz(d)) n--; }
    return d;
  }
  function fmt(dt, withDay) {
    return dt.toLocaleDateString('en-US', { timeZone: 'UTC', weekday: withDay ? 'short' : undefined, month: 'short', day: 'numeric' });
  }
  function compute(el) {
    var cutoff = 24; /* orders placed before midnight New York time count as today */
    var min = parseInt(el.getAttribute('data-min') || '4', 10);
    var max = parseInt(el.getAttribute('data-max') || '7', 10);
    var withDay = el.getAttribute('data-weekday') !== 'false';
    var n = nyNow();
    var start = new Date(Date.UTC(n.y, n.m - 1, n.d));
    var beforeCutoff = isBiz(start) && n.h < cutoff;
    if (!beforeCutoff) start = addBiz(start, 1);
    var from = addBiz(start, min), to = addBiz(start, max);
    var range = el.querySelector('[data-pc-range]');
    if (range) range.textContent = fmt(from, withDay) + ' – ' + fmt(to, withDay);
    var left = (cutoff * 60) - (n.h * 60 + n.min);
    var lh = Math.floor(left / 60), lm = left % 60;
    var tt = (lh > 0 ? lh + (lh === 1 ? ' hr ' : ' hrs ') : '') + lm + (lm === 1 ? ' min' : ' mins');
    var lead = el.querySelector('[data-pc-lead]');
    if (lead) {
      if (beforeCutoff) lead.innerHTML = 'Order within <b class="pc-delivery__time">' + tt + '</b> and get it by';
      else lead.textContent = lead.getAttribute('data-default') || 'Get it by';
    }
    var c = el.querySelector('[data-pc-cutoff]');
    if (c) {
      if (beforeCutoff) {
        var left = (cutoff * 60) - (n.h * 60 + n.min);
        var hrs = Math.floor(left / 60), mins = left % 60;
        var t = (hrs > 0 ? hrs + (hrs === 1 ? ' hr ' : ' hrs ') : '') + mins + (mins === 1 ? ' min' : ' mins');
        c.innerHTML = 'Order within <b>' + t + '</b> to get it by these dates';
        c.hidden = false;
      } else {
        c.hidden = true;
      }
    }
  }
  window.PetceteraDelivery = {
    renderAll: function () { document.querySelectorAll('[data-pc-delivery]').forEach(compute); }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.PetceteraDelivery.renderAll);
  } else {
    window.PetceteraDelivery.renderAll();
  }
  setInterval(window.PetceteraDelivery.renderAll, 60000);
})();
